import React, {FunctionComponent, useEffect, useState} from "react";
import {EuiComboBox, EuiFlexItem, EuiFormRow} from "@elastic/eui";

interface option{
    "label":string,
    "value": any
};

export const CatalystSelection:(props: any) => JSX.Element = (props) =>{


    const [options,setOption] = useState<option[]>([])
    const [optionLoading,setOptionLoading] = useState(true)
    const [selectedOption,setSelectedOption] = useState()
    const onChange = (selectedOptions:any) => {
        setSelectedOption(selectedOptions);
        props.selectedOptions(selectedOptions);

    };



    useEffect(()=>{
        if(props.addAll){
            let tempOpts = props.options ;
            let all = [{"label": "All","value": -1}]
            const opts = all.concat(tempOpts)
            setOption(opts)
            setOptionLoading(false)
        }else {
            setOption(props.options)
            setOptionLoading(false)
        }
    },[props.options])


    function getEuiSelection() {
        let placeHolder = "Select "+ props.labelName;

        if(props.multiSelect){
            return(<EuiFlexItem>
                <EuiFormRow label={props.labelName}>
                    <EuiComboBox
                        placeholder={placeHolder}
                        options={options}
                        selectedOptions={selectedOption}
                        onChange={onChange}
                        isClearable={true}
                        isLoading={optionLoading}
                    />

                </EuiFormRow>
            </EuiFlexItem>)
        }
        else {
            return (<EuiFlexItem>
                <EuiFormRow label={props.labelName}>
                    <EuiComboBox
                        placeholder={placeHolder}
                        singleSelection={{ asPlainText: true }}
                        options={options}
                        selectedOptions={selectedOption}
                        onChange={onChange}
                    />

                </EuiFormRow>
            </EuiFlexItem>)
        }
    }

    return(
        getEuiSelection()
    )
}